import { ApplicationDMQueueParams, SearchParams } from '@lk/api'
import { CommitteeParams } from '@lk/api/application/models/committee-params.models'
import { createAsyncThunk, createAction } from '@reduxjs/toolkit'
import { ThunkApi } from '../index.d'
import {
  ApplicationDeleteParams,
  ApplicationEditParams,
} from '@lk/api/application/models/application/application-add.params.model'
import { ApplicationAddParams } from '@lk/api/application/models/application/application-add.params.model'

export const applicationSearch = createAsyncThunk<any, SearchParams, ThunkApi>(
  '[APPLICATION/SEARCH] SEARCH',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const { instanceName } = params

    if (instanceName) {
      delete params.instanceName
    }

    const result = await extra.api.application.search('search', params)
    console.log(result.data)
    if (result.success) {
      if (instanceName) {
        return {
          instanceName: instanceName,
          data: result.data,
        }
      }

      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const applicationSearchAgain = createAsyncThunk<any, string, ThunkApi>(
  '[APPLICATION/SEARCH] SEARCH_AGAIN',
  async (instanceName, { extra, rejectWithValue, getState }) => {
    const state = getState()

    const prevSeatchParams = { ...state.applicationSearch.previousSearchParams[instanceName] }
    if (prevSeatchParams.instanceName) {
      delete prevSeatchParams.instanceName
    }

    const result = await extra.api.application.search('search', prevSeatchParams)

    if (result.success) {
      if (instanceName) {
        return {
          instanceName: instanceName,
          data: result.data,
        }
      }
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const applicationSearchBIC = createAsyncThunk<any, SearchParams, ThunkApi>(
  '[APPLICATION/SEARCH] SEARCH_BIC',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.search('searchbic', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const approveCommittee = createAsyncThunk<any, Partial<CommitteeParams> & Record<string, unknown>, ThunkApi>(
  '[APPLICATION/COMMITTIEE] APPROVE_COMMITTEE',
  async ({ AppID, HashSum_AppID_, ...rest }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.approveCommittee(AppID, HashSum_AppID_, rest)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const validateCommittee = createAsyncThunk<any, Partial<CommitteeParams> & Record<string, unknown>, ThunkApi>(
  '[APPLICATION/COMMITTIEE] VALIDATE_COMMITTEE',
  async ({ AppID, HashSum_AppID_ }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.validateCommittee(AppID, HashSum_AppID_)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const deleteCommittee = createAsyncThunk<any, Partial<CommitteeParams> & Record<string, unknown>, ThunkApi>(
  '[APPLICATION/COMMITTIEE] DELETE_COMMITTEE',
  async ({ AppID, HashSum_AppID_, ComitteeID, HashSum_ComitteeID_ }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.deleteCommittee({
      AppID,
      HashSum_AppID_,
      ComitteeID,
      HashSum_ComitteeID_,
    })

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const viewCommittee = createAsyncThunk<any, Partial<CommitteeParams> & Record<string, unknown>, ThunkApi>(
  '[APPLICATION/COMMITTIEE] VIEW_COMMITTEE',
  async ({ AppID, HashSum_AppID_, ComitteeID, HashSum_ComitteeID_ }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.viewCommittee({
      AppID,
      HashSum_AppID_,
      ComitteeID,
      HashSum_ComitteeID_,
    })

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const viewCustFieldCommittee = createAsyncThunk<
  any,
  Partial<CommitteeParams> & Record<string, unknown>,
  ThunkApi
>(
  '[APPLICATION/COMMITTIEE] VIEW_CUSTOM_FIELDS_COMMITTEE',
  async ({ AppID, HashSum_AppID_, ComitteeID, HashSum_ComitteeID_ }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.viewCustFieldsCommittee({
      AppID,
      HashSum_AppID_,
      ComitteeID,
      HashSum_ComitteeID_,
    })

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const rejectCommittee = createAsyncThunk<any, Partial<CommitteeParams> & Record<string, unknown>, ThunkApi>(
  '[APPLICATION/COMMITTIEE] REJECT_COMMITTEE',
  async ({ AppID, HashSum_AppID_, ComitteeID, HashSum_ComitteeID_, ...rest }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.rejectCommittee(
      {
        AppID,
        HashSum_AppID_,
        ComitteeID,
        HashSum_ComitteeID_,
      },
      rest,
    )

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const suspendCommittee = createAsyncThunk<any, Partial<CommitteeParams> & Record<string, unknown>, ThunkApi>(
  '[APPLICATION/COMMITTIEE] SUSPEND_COMMITTEE',
  async ({ AppID, HashSum_AppID_, ComitteeID, HashSum_ComitteeID_, ...rest }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.suspendCommittee(
      {
        AppID,
        HashSum_AppID_,
        ComitteeID,
        HashSum_ComitteeID_,
      },
      rest,
    )

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const applicationDmQueue = createAsyncThunk<any, ApplicationDMQueueParams, ThunkApi>(
  '[APPLICATION] DM_QUEUE',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.dmQueue(params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const applicationAdd = createAsyncThunk<any, ApplicationAddParams, ThunkApi>(
  '[APPLICATION] ADD',
  async (data, { extra, rejectWithValue }) => {
    const result = await extra.api.application.applicationAdd(data)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error)
  },
)

export const applicationEdit = createAsyncThunk<any, ApplicationEditParams, ThunkApi>(
  '[APPLICATION] EDIT',
  async (data, { extra, rejectWithValue }) => {
    const result = await extra.api.application.applicationEdit(data)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error)
  },
)

export const applicationDelete = createAsyncThunk<any, ApplicationDeleteParams, ThunkApi>(
  '[APPLICATION] DELETE',
  async (data, { extra, rejectWithValue }) => {
    const result = await extra.api.application.applicationDelete(data)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)
